module.exports = __webpack_public_path__ + "static/media/add-icon-dark.5af822db.svg";